<div
  class="channel"
  [ngStyle]="{
    'background-image': 'url(' + (mini ? channel.miniUrl : channel.url) + ')',
    'width': mini ? channel.miniWidth : params.large ? channel.largeWidth : channel.width
  }"
  *ngFor="let channel of channels"
></div>
